import * as React from 'react'
import styles from './contact-style.css'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Heading from '../Heading/Heading'
import Icon from '../Icon/Icon'
import { phoneIcon } from '../../icons'
import cx from 'classnames'
import Button from '../Button/Button'
type Props = {
  phoneNumber?: string
  linkList?: Array<LinkViewModel>
  // @deprecated
  text?: string
  // @internal
  className?: string
}
export const renderPhone = (phoneNumber: any, className?: string) => {
  if (!phoneNumber) return null
  return (
    <div className={cx(styles.phoneContainer, className && className)}>
      <Icon iconSrc={phoneIcon} width={'18px'} height={'18px'} />
      <Heading className={styles.heading} level={2} tag={'h3'}>
        {phoneNumber}
      </Heading>
    </div>
  )
}

function Contact({ phoneNumber, linkList, text, className }: Props) {
  return (
    <div className={cx(styles.contact, className && className)}>
      {renderPhone(phoneNumber)}
      <ul className={styles.listWrapper}>
        {linkList &&
          linkList.map((link) => (
            <li className={styles.listItem} key={link.label}>
              <Button secondary darkBg {...link} />
            </li>
          ))}
      </ul>
    </div>
  )
}

Contact.displayName = 'Contact'
Contact.defaultProps = {}
export default Contact